export default __webpack_public_path__ + "static/media/image_11.c0fb85ec.jpg";